module.exports = __webpack_public_path__ + "components/weather-icon/static/daysnowshowers@3-8301d69fb4f6c0c65059924f935f7d7c.png";